webpackJsonp([6],{

/***/ 750:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(793);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f026541_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(846);
function injectStyle (ssrContext) {
  __webpack_require__(843)
}
var normalizeComponent = __webpack_require__(105)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f026541"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f026541_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 793:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_profile__ = __webpack_require__(845);



//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profile',
  data: function data() {
    return {
      setting: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    setNavigatorLinks: 'navigator/setLinks',
    setNavigatorTitle: 'navigator/setTitle'
  }), {
    fetchSetting: function fetchSetting() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__api_profile__["a" /* default */].get();

              case 2:
                res = _context.sent;

                _this.setting = res.data.data;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    change: function change() {
      __WEBPACK_IMPORTED_MODULE_4__api_profile__["a" /* default */].store(this.setting);
    }
  }),
  mounted: function mounted() {
    this.setNavigatorLinks([]);
    this.setNavigatorTitle('設定');
    this.fetchSetting();
  }
});

/***/ }),

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(844);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(732)("af835e0e", content, true, {});

/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(731)(true);
// imports


// module
exports.push([module.i, ".setting_form .item[data-v-5f026541]{padding:20px}.setting_form .item .label[data-v-5f026541]{font-size:14px;font-weight:700;color:#0068b6}.setting_form .save-setting-btn[data-v-5f026541]{position:fixed;top:20px;color:#fff;z-index:21;right:20px;text-decoration:none}", "", {"version":3,"sources":["/Users/trungnq/Code/vital/sns/public/pwa/src/screens/profile/index.vue"],"names":[],"mappings":"AACA,qCACE,YAAc,CACf,AACD,4CACI,eAAgB,AAChB,gBAAkB,AAClB,aAAe,CAClB,AACD,iDACE,eAAgB,AAChB,SAAU,AACV,WAAY,AACZ,WAAY,AACZ,WAAY,AACZ,oBAAsB,CACvB","file":"index.vue","sourcesContent":["\n.setting_form .item[data-v-5f026541] {\n  padding: 20px;\n}\n.setting_form .item .label[data-v-5f026541] {\n    font-size: 14px;\n    font-weight: bold;\n    color: #0068b6;\n}\n.setting_form .save-setting-btn[data-v-5f026541] {\n  position: fixed;\n  top: 20px;\n  color: #fff;\n  z-index: 21;\n  right: 20px;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 845:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(69);


var resource = 'profile';
var get = function get() {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get('' + resource);
};
var store = function store(data) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].post('' + resource, data);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  get: get,
  store: store
});

/***/ }),

/***/ 846:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile_page"},[(_vm.setting)?_c('div',{staticClass:"setting_form"},[_c('div',{staticClass:"item clearfix"},[_c('div',{staticClass:"label f-l label-setting-notification"},[_vm._v("メール配信")]),_vm._v(" "),_c('div',{staticClass:"input f-r"},[_c('el-switch',{on:{"change":_vm.change},model:{value:(_vm.setting.is_notification_new_message),callback:function ($$v) {_vm.$set(_vm.setting, "is_notification_new_message", $$v)},expression:"setting.is_notification_new_message"}})],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/6.54a01c70c6aa6e3f81b3.js